import React, { forwardRef } from 'react';

export type CheckboxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: React.ReactNode;
  description?: React.ReactNode;
};

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  function Checkbox({ label, description, style, ...rest }, ref) {
    return (
      <label
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '0.625rem',
          cursor: 'pointer',
          ...style
        }}
      >
        <input
          ref={ref}
          type="checkbox"
          {...rest}
          style={{ marginTop: '0.125rem' }}
        />
        <span
          style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}
        >
          {label && (
            <span
              style={{
                fontSize: 'var(--font-size-base)',
                fontWeight: 'var(--font-weight-bold)',
                lineHeight: '1.5rem',
                color: 'var(--color-text-primary, #1a1a1a)'
              }}
            >
              {label}
            </span>
          )}
          {description && (
            <span
              style={{
                fontSize: '0.875rem',
                color: 'var(--color-text-secondary, #4b5563)'
              }}
            >
              {description}
            </span>
          )}
        </span>
      </label>
    );
  }
);
